import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { receipts, receiptsIntro } from "../data/receipts";
import { SectionHeading } from "./SectionHeading";
import { BODY, EYEBROW, H3, LEAD } from "../utils/typography";
const ease = [0.23, 1, 0.32, 1] as const;

/** A short ledger of recognitions, credentials and communities — set like a receipt. */
export function ReceiptsSection() {
  const reduce = useReducedMotion();
  return <section id="receipts" aria-labelledby="receipts-heading" className="w-full scroll-mt-28 bg-cream px-6 pb-24 md:scroll-mt-36 md:px-12 md:pb-32 lg:px-20 lg:pb-40" data-id="element-285" data-mp="2ev2e7cc5oh5q">
      <SectionHeading id="receipts-heading" title="A FEW RECEIPTS." data-id="element-286" data-mp="253fvyw1ehhth" />

      <div className="mt-24 grid grid-cols-1 gap-12 md:mt-32 lg:mt-40 lg:grid-cols-12" data-id="element-287" data-mp="2054jsenmuv83">
        <motion.p className={`${LEAD} text-espresso lg:col-span-4`} initial={reduce ? false : {
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.3,
        ease
      }} data-id="element-288" data-mp="1v58i4m2erfvp">
          {receiptsIntro}
        </motion.p>

        {/* Dashed rules echo a printed receipt */}
        <ul className="border-b border-dashed border-espresso/25 lg:col-span-8" data-id="element-289" data-mp="phfki2avrwh0">
          {receipts.map((item, i) => <motion.li key={item.title} className="grid grid-cols-1 gap-3 border-t border-dashed border-espresso/25 py-8 md:grid-cols-12 md:gap-8 md:py-10" initial={reduce ? false : {
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.5
        }} transition={{
          duration: 0.3,
          ease,
          delay: i * 0.05
        }} data-id="element-290" data-mp="uh1xqbqplcpt" data-mpi={i}>
              <p className={`${EYEBROW} text-rust md:col-span-3 md:pt-1`} data-id="element-291" data-mp="1d4ov3tqzp32z">{item.category}</p>
              <div className="md:col-span-9" data-id="element-292" data-mp="3ttu7qos9iv2o">
                <h3 className={`${H3} text-espresso`} data-id="element-293" data-mp="1ruoahppv2ps">{item.title}</h3>
                {item.source && <p className={`mt-1 ${EYEBROW} text-espresso/70`} data-id="element-294" data-mp="24e09xv65qq8i">{item.source}</p>}
                <p className={`mt-3 max-w-xl ${BODY} text-espresso/75`} data-id="element-295" data-mp="24fulwjzgb80g">{item.description}</p>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}